/* EHi2 — Estate Entertainment — theme interactions */
(function(){
  "use strict";

  function initScrollNav(){
    var nav = document.getElementById('siteNav');
    if(!nav) return;
    window.addEventListener('scroll', function(){
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, {passive:true});
  }

  function initMobileNav(){
    var overlay = document.getElementById('mobileNav');
    var openBtn = document.getElementById('hamburgerBtn');
    var closeBtn = document.getElementById('mobileNavClose');
    if(!overlay || !openBtn) return;
    openBtn.addEventListener('click', function(){ overlay.hidden = false; });
    if(closeBtn) closeBtn.addEventListener('click', function(){ overlay.hidden = true; });
  }

  function initReveal(){
    var items = document.querySelectorAll('.reveal');
    if(!items.length) return;
    if(!('IntersectionObserver' in window)){ items.forEach(function(i){i.classList.add('in-view');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('in-view'); io.unobserve(entry.target); }
      });
    }, {threshold:.14});
    items.forEach(function(i){ io.observe(i); });
  }

  function toggleSwitch(btn){
    var on = btn.classList.toggle('on');
    btn.setAttribute('aria-checked', on ? 'true' : 'false');
    return on;
  }

  function initCookieConsent(){
    var banner = document.getElementById('cookieBanner');
    if(!banner) return;
    var modal = document.getElementById('cookieModal');
    var stored = null;
    try{ stored = JSON.parse(localStorage.getItem('ehi2_cookie_prefs')||'null'); }catch(e){}
    if(!stored){ setTimeout(function(){ banner.hidden = false; }, 900); }

    function persist(prefs){
      try{ localStorage.setItem('ehi2_cookie_prefs', JSON.stringify(prefs)); }catch(e){}
    }
    var acceptAll = document.getElementById('cookieAcceptAll');
    var rejectAll = document.getElementById('cookieRejectAll');
    var manage = document.getElementById('cookieManage');
    var modalClose = document.getElementById('cookieModalClose');
    var a = document.getElementById('toggleAnalytics');
    var m = document.getElementById('toggleMarketing');
    var save = document.getElementById('cookieSavePrefs');

    if(acceptAll) acceptAll.addEventListener('click', function(){ persist({analytics:true,marketing:true}); banner.hidden = true; });
    if(rejectAll) rejectAll.addEventListener('click', function(){ persist({analytics:false,marketing:false}); banner.hidden = true; });
    if(manage && modal) manage.addEventListener('click', function(){ modal.hidden = false; });
    if(modalClose && modal) modalClose.addEventListener('click', function(){ modal.hidden = true; });
    if(a) a.addEventListener('click', function(){ toggleSwitch(a); });
    if(m) m.addEventListener('click', function(){ toggleSwitch(m); });
    if(save) save.addEventListener('click', function(){
      persist({analytics: a ? a.classList.contains('on') : false, marketing: m ? m.classList.contains('on') : false});
      if(modal) modal.hidden = true;
      banner.hidden = true;
    });
    if(modal) modal.addEventListener('click', function(e){ if(e.target===modal) modal.hidden = true; });

    // "Cookie Settings" links anywhere on the site (e.g. footer) reopen preferences
    document.querySelectorAll('[data-open-cookie-settings]').forEach(function(link){
      link.addEventListener('click', function(e){
        e.preventDefault();
        banner.hidden = false;
        if(modal) modal.hidden = false;
      });
    });
  }

  function initLightbox(){
    var lightbox = document.getElementById('ehi2Lightbox');
    if(!lightbox) return;
    var img = document.getElementById('ehi2LightboxImg');
    var caption = document.getElementById('ehi2LightboxCaption');
    var closeBtn = lightbox.querySelector('.ehi2-lightbox-close');

    function open(src, text){
      img.src = src;
      img.alt = text || '';
      caption.textContent = text || '';
      lightbox.hidden = false;
    }
    function close(){
      lightbox.hidden = true;
      img.src = '';
    }

    document.querySelectorAll('.lightbox-trigger').forEach(function(tile){
      var src = tile.getAttribute('data-full-src');
      if(!src) return;
      tile.addEventListener('click', function(){ open(src, tile.getAttribute('data-caption')); });
      tile.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); open(src, tile.getAttribute('data-caption')); }
      });
    });

    closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function(e){ if(e.target === lightbox) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initScrollNav();
    initMobileNav();
    initReveal();
    initCookieConsent();
    initLightbox();
  });
})();
